/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_Never_TextInputs */

const es_privacy_policy_sharing_never_text = /** @type {(inputs: Privacy_Policy_Sharing_Never_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vendemos sus datos personales, compartimos contenido de archivos con anunciantes, ni proporcionamos acceso a sus embeddings a terceros.`)
};

const en_privacy_policy_sharing_never_text = /** @type {(inputs: Privacy_Policy_Sharing_Never_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`we sell your personal data, share file contents with advertisers, or provide access to your embeddings to third parties.`)
};

/**
* | output |
* | --- |
* | "we sell your personal data, share file contents with advertisers, or provide access to your embeddings to third parties." |
*
* @param {Privacy_Policy_Sharing_Never_TextInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_never_text = /** @type {((inputs?: Privacy_Policy_Sharing_Never_TextInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_Never_TextInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_never_text(inputs)
	return en_privacy_policy_sharing_never_text(inputs)
});
export { privacy_policy_sharing_never_text as "privacy_policy.sharing.never_text" }